import { Howl } from "howler";
import { Subject } from "rxjs";
import { logSound } from "../logging/logging";
import { IdEventSoundCore } from "./IdEventSoundCore";
import { IdSoundGroup } from "./IdSoundGroup";
var UtilSound = /** @class */ (function () {
    function UtilSound() {
        var _this = this;
        this.CodecsByPreference = ["ogg", "m4a", "mp3", "ac3"];
        this.supportedCodec = this.CodecsByPreference.find(function (codec) { return Howler.codecs(codec); }) || this.CodecsByPreference[0];
        this.loaded$ = new Subject();
        this.soundGroupVolumeChange$ = new Subject();
        this.howlsByGroupId = new Map();
        this.muteStatusByGroupId = new Map();
        this.playingSoundsById = new Map();
        this.eventConfig = {};
        this.isSoundGroupMuted = function (group) {
            return !!_this.muteStatusByGroupId.get(group);
        };
        this.muteSoundGroup = function (group, mute) {
            var volume = mute ? 0 : 1;
            _this.muteStatusByGroupId.set(group, mute);
            if (group === IdSoundGroup.Global) {
                _this.howlsByGroupId.forEach(function (val, key) {
                    if (mute || !_this.isSoundGroupMuted(key)) {
                        val.volume(volume);
                    }
                });
                _this.soundGroupVolumeChange$.next([group, volume]);
                return;
            }
            var howl = _this.howlsByGroupId.get(group);
            if (!howl) {
                _this.soundGroupVolumeChange$.next([group, volume]);
                return;
            }
            volume = _this.isSoundGroupMuted(IdSoundGroup.Global) ? 0 : volume;
            _this.soundGroupVolumeChange$.next([group, volume]);
            howl.volume(volume);
        };
        this.playSound = function (sound, loop) {
            if (loop === void 0) { loop = false; }
            var howl = _this.howlsByGroupId.get(sound.group);
            if (!howl) {
                return;
            }
            var previousSound = _this.playingSoundsById.get(sound.id);
            if (previousSound) {
                howl.stop(previousSound);
            }
            var id = howl.play(sound.id);
            howl.loop(loop, id);
            _this.playingSoundsById.set(sound.id, id);
            return howl;
        };
        this.playSounds = function (sounds, inSequence, loop, delayInBetween) {
            if (inSequence === void 0) { inSequence = false; }
            if (loop === void 0) { loop = false; }
            if (delayInBetween === void 0) { delayInBetween = 0; }
            if (sounds.length === 0) {
                return;
            }
            if (!inSequence) {
                sounds.forEach(function (sound) { return _this.playSound(sound, loop); });
                return;
            }
            _this.playInSequence(sounds.slice(), delayInBetween);
        };
        this.stopSound = function (sound) {
            var howl = _this.howlsByGroupId.get(sound.group);
            if (!howl || !_this.playingSoundsById.has(sound.id)) {
                return;
            }
            howl.stop(_this.playingSoundsById.get(sound.id));
        };
        this.event = function (event) {
            var config = _this.eventConfig[event];
            logSound("Event: " + IdEventSoundCore[event]);
            if (!config) {
                return;
            }
            if (config.stop) {
                config.stop.forEach(function (sound) { return _this.stopSound(sound); });
            }
            if (config.play) {
                _this.playSounds(config.play, config.playInSequence, config.loop, config.delayInBetween);
            }
        };
        this.eventWithParams = function (event) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            var config = _this.eventConfig[event];
            logSound("Event with params: " + IdEventSoundCore[event], params);
            if (!config) {
                return;
            }
            if (config.stopWithParams) {
                config.stopWithParams.apply(config, params).forEach(function (sound) { return _this.stopSound(sound); });
            }
            if (config.playWithParams) {
                _this.playSounds(config.playWithParams.apply(config, params), config.playInSequence, config.loop, config.delayInBetween);
            }
        };
        this.setEventConfig = function (config) {
            _this.eventConfig = config;
        };
        this.registerSounds = function (id, url, config) {
            var sprite = Object.keys(config).reduce(function (acc, key) {
                var sound = config[key];
                if (sound.group === id) {
                    acc[key] = sound.range;
                }
                return acc;
            }, {});
            var howl = new Howl({
                onload: function () { return _this.loaded$.next(id); },
                sprite: sprite,
                src: url,
            });
            var globalVolume = _this.isSoundGroupMuted(IdSoundGroup.Global) ? 0 : 1;
            var groupVolume = _this.isSoundGroupMuted(id) ? 0 : 1;
            var volume = Math.min(globalVolume, groupVolume);
            howl.volume(volume);
            _this.howlsByGroupId.set(id, howl);
        };
        this.isSoundGroupLoaded = function (id) {
            return _this.howlsByGroupId.has(id) && _this.howlsByGroupId.get(id).state() === "loaded";
        };
        this.playInSequence = function (sounds, delayInBetween) {
            if (delayInBetween === void 0) { delayInBetween = 0; }
            var sound = sounds.shift();
            if (!sound) {
                return;
            }
            _this.playSound(sound).once("end", function () {
                return setTimeout(function () { return _this.playInSequence(sounds, delayInBetween); }, delayInBetween);
            });
        };
    }
    return UtilSound;
}());
export var utilSound = new UtilSound();



//////////////////
// WEBPACK FOOTER
// ./src/utils/sound/utilSound.ts
// module id = 64
// module chunks = 3